import {
  AfterContentChecked,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output, SimpleChanges
} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {PaymentInfo, StaticMethods} from '../../model/GeneralModels';
import {AppSettingsService} from '../../services/app-settings.service';
import {FinanceService} from '../../services/finance.service';
import {MatDialog} from '@angular/material/dialog';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-invoice',
  template: `
    <app-main-nav-bar></app-main-nav-bar>
    <div class="main" data-request="1995">
      <div class="wrap">
        <div class="wrap">
          <div>
            <div class="row">
              <div class="col col-12">
                <div class="head">
                  <i class="icon ico-shopping-cart-outline"></i>
                  <h2>پرداخت حق بیمه</h2>
                  <p>همین الان حق بیمه خودتون را پرداخت کنید</p>
                </div>
              </div>
            </div>
            <div class="row" *ngIf="paymentInfo.personCount">
              <div class="col col-12">
                <div class="txt-justify">
                  <p>این صورتحساب برای <span class="person-count">{{paymentInfo.personCount}}</span> نفر از بیمه گذاران
                    صادر
                    شده است.
                  </p>
                </div>
              </div>
            </div>
            <div class="row">
              <div *ngIf="paymentInfo.paymentMode === 'CASH' && !paymentInfo.noDiscounts " class="col col-12">
                <app-input-field
                  [Icon]="false"
                  [fieldLabel]="'کد تخفیف'"
                  [fieldName]="'discountCode'"
                  [Group]="Group"
                  [dataType]="['text']"
                  [button]="false"
                  [clearButton]="true"
                  [buttonLabel]="'اعمال'"
                  [inProgress]="inProgress"
                  (OnChange)="setChanged()"
                  (OnButtonClicked)="generateWithDiscountCode()"
                ></app-input-field>
              </div>
            </div>
            <div class="row" style="height: 45px;">
              <div class="col col-12">
                <div class="col col-6">
                  <h3 style="line-height: 33px;">مبلغ کل</h3>
                </div>
                <div class="col col-6">
                  <div>
                <span class="mark"
                      dir="ltr">{{paymentInfo.discountedAmountString}}</span>
                    <span style="float: left">تومان</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row" style="height: 45px;">
              <div class="col col-12">
                <div class="col col-6">
                  <h3 style="line-height: 33px;">نوع پرداخت</h3>
                </div>
                <div class="col col-6">
                  <div>
                <span dir="ltr"
                      style="float: left">{{settings.translateEnglish(paymentInfo.paymentMode, translation)}}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row" style="height: 45px;" *ngIf="paymentInfo.visitCost">
              <div class="col col-12">
                <div class="col col-6">
                  <h3 style="line-height: 33px;">هزینه ویزیت</h3>
                </div>
                <div class="col col-6">
                  <div>
                    <span class="mark" dir="ltr">{{paymentInfo.visitCost}}</span>
                    <span style="float: left">تومان</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row" *ngIf="paymentInfo.discountSumString !== ''">
              <div class="col col-12">
                <div class="col col-6">
                  <h3 style="line-height: 33px;">تخفیفات</h3>
                </div>
                <div class="col col-6">
                  <div>
                    <span class="mark" dir="ltr">{{paymentInfo.discountSumString}}</span>
                    <span style="float: left">تومان</span>
                  </div>
                </div>
              </div>
              <ol>
                <li *ngFor="let discount of paymentInfo.discountsList">
                  <span class="discounts">{{discount}}</span>
                </li>
              </ol>
            </div>
            <div class="row" *ngIf="paymentInfo.addedValue">
              <div class="col col-6">
                <h3 style="line-height: 33px;">{{paymentInfo.addedValue.label}}</h3>
              </div>
              <div class="col col-6">
                <div>
                  <span class="mark" dir="ltr">{{paymentInfo.addedAmountString}}</span>
                  <span style="float: left">تومان</span>
                </div>
              </div>
            </div>
            <div class="row" style="height: 45px;">
              <div class="col col-12">
                <div class="col col-6">
                  <h3 style="line-height: 33px;">اطلاعات بیمه</h3>
                </div>
                <div class="col col-6">
                  <div>
                    <span dir="ltr" style="float: left">{{paymentInfo.offerName}}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row" style="height: 45px;">
              <div class="col col-12">
                <div class="col col-6">
                  <h3 style="line-height: 33px;">مبلغ قابل پرداخت</h3>
                </div>
                <div class="col col-6">
                  <div>
                    <span class="mark" dir="ltr">{{paymentInfo.amountString}}</span>
                    <span style="float: left;">تومان</span>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="paymentInfo.resnum" class="row" style="height: 45px;">
              <div class="col col-12">
                <div class="col col-6">
                  <h3 style="line-height: 33px;">شماره فاکتور</h3>
                </div>
                <div class="col col-6">
                  <div>
                    <span dir="ltr" style="float: left">{{paymentInfo.resnum}}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row" style="height: 45px;"
                 *ngIf="paymentInfo && paymentInfo.availablePaymentPorts && paymentInfo.availablePaymentPorts.length > 1">
              <app-radio-button [translation]="translation" [fieldName]="'paymentPort'" [Group]="Group"
                                [list]="paymentInfo.availablePaymentPorts" (OnChange)="setChanged()"></app-radio-button>
            </div>
          </div>
          <div class="row" style="float: left"
               *ngIf="paymentInfo && paymentInfo.availablePaymentModes && paymentInfo.availablePaymentModes.length">
            <div style="float: left">
              <div class="pull-right" style="margin-left: 2px"
                   *ngIf="contains('INSTALLMENT', paymentInfo.availablePaymentModes);">
                <a class="link link-pay">
                  <div (click)="goToPayment('INSTALLMENT')"
                       [ngClass]="paymentInfo.paymentMode === 'INSTALLMENT'? 'push push-enabled' : 'push push-disabled'"
                       style="height: 32px">
                    <i class="icon ico-shopping-bag-outline"></i>
                    <span>{{paymentInfo.paymentMode === 'INSTALLMENT' ? 'پرداخت کنید' : 'قسطی'}}</span>
                  </div>
                </a>
              </div>
              <div class="pull-left" *ngIf="contains('CASH', paymentInfo.availablePaymentModes);">
                <a class="link link-pay">
                  <div (click)="goToPayment('CASH')" class="push"
                       [ngClass]="paymentInfo.paymentMode === 'CASH'? 'push push-enabled' : 'push push-disabled'"
                       style="height: 32px">
                    <i class="icon ico-shopping-bag-outline"></i>
                    <span>{{paymentInfo.paymentMode === 'CASH' ? 'پرداخت کنید' : 'نقدی'}}</span>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,
  styleUrls: [
    '../../assets/Content/src/css/lib.vendor.css',
    '../../assets/Content/src/css/ini.bime.css',
    '../../assets/css/light.theme.css'
  ],
  styles: [`
    .factor .link {
      white-space: pre-wrap !important;
    }

    .icon {
      color: #fff !important;
    }

    .push {
      padding: 0 15px;
      overflow: hidden;
      position: inherit !important;
      top: 0;
      left: 0;
      bottom: 0;
      text-align: center;
      line-height: 38px;
      color: #fff;
      text-overflow: ellipsis;
      white-space: nowrap;
      border-radius: 3px;
      min-width: 106px;
    }

    .loader {
      left: 50%;
      top: 50%;
    }

    .loader-div {
      height: 50px;
    }

    .push-enabled {
      background-color: #12b886 !important;
    }

    .push-disabled {
      background-color: #537EC5 !important;
    }

    .span-enabled:before {
      visibility: hidden;
    }

    .span-enabled:after {
      content: 'پرداخت کنید';
    }
  `]
})
export class InvoiceComponent implements OnInit, OnChanges, AfterContentChecked {
  RequestID: number;
  productName: string;
  paymentMode: string;
  translation: any = {};
  paymentInfo: PaymentInfo = new PaymentInfo();
  errorMessage: string;
  Group: FormGroup = new FormGroup({
    paymentPort: new FormControl('', Validators.required),
    discountCode: new FormControl('')
  });
  inProgress: boolean;
  changed = false;

  constructor(private cdRef: ChangeDetectorRef,
              public settings: AppSettingsService,
              private service: FinanceService,
              private dialog: MatDialog,
              private activatedRoute: ActivatedRoute) {
  }

  ngOnInit() {
    this.activatedRoute.params.subscribe(params => {
      this.RequestID = params.requestID;
      this.productName = params.productName;
    });
    this.generateInvoice(null, 'CASH');
  }

  goToPayment(paymentMode) {
    if (paymentMode !== this.paymentMode) {
      this.generateInvoice(this.Group.controls.discountCode.value, paymentMode, null, () => {
      });
    } else if (this.Group.controls.paymentPort.valid) {
      if (this.changed) {
        this.generateInvoice(this.Group.controls.discountCode.value, paymentMode,
          this.Group.controls.paymentPort.value, () => {
            StaticMethods.redirectToPayment(this.paymentInfo, this.dialog, this.service, this.productName,
              this.Group.controls.paymentPort.value,
              (reload, newPaymentMode) => {
                if (reload) {
                  this.generateInvoice(this.Group.controls.discountCode.value, newPaymentMode);
                }
              });
          });
      } else {
        StaticMethods.redirectToPayment(this.paymentInfo, this.dialog, this.service, this.productName,
          this.Group.controls.paymentPort.value,
          (reload, newPaymentMode) => {
            if (reload) {
              this.generateInvoice(this.Group.controls.discountCode.value, newPaymentMode);
            }
          });
      }
    } else {
      StaticMethods.showMessage('لطفا درگاه مد نظر را انتخاب نمایید');
    }
  }

  ngAfterContentChecked() {
    this.cdRef.detectChanges();
  }

  ngOnChanges(changes: SimpleChanges): void {
    // if (this.paymentInfo && this.paymentInfo.addedValue) {
    //   this.paymentInfo.addedValue.addedAmountString = StaticMethods.numberWithCommas(this.paymentInfo.addedValue.addedAmount);
    // }
  }

  generateInvoice(discountCode, paymentMode, paymentPort?: string, cb?: any) {
    if (paymentMode !== this.paymentMode) {
      this.setChanged();
    }
    this.inProgress = true;
    this.service.invoice(
      this.RequestID,
      this.productName,
      discountCode,
      paymentMode,
      paymentPort
    ).subscribe(response => {
      if (response.success) {
        console.log(response);
        this.translation = StaticMethods.appendTranslation(response.translation, this.translation);
        this.paymentInfo.setData(response.data);
        this.paymentMode = this.paymentInfo.paymentMode;
        if (this.paymentInfo.selectedPaymentPort) {
          this.Group.controls.paymentPort.patchValue(this.paymentInfo.selectedPaymentPort);
        } else if (this.paymentInfo.availablePaymentPorts.length === 1) {
          this.Group.controls.paymentPort.patchValue(this.paymentInfo.availablePaymentPorts[0]);
          console.log(this.paymentInfo.availablePaymentPorts[0]);
        } else if (this.Group.controls.paymentPort.value === '' ||
          !this.contains(this.Group.controls.paymentPort.value, this.paymentInfo.availablePaymentPorts)
        ) {
          this.Group.controls.paymentPort.patchValue(this.paymentInfo.availablePaymentPorts[0]);
        }
        this.inProgress = false;
        this.changed = false;
        if (cb) {
          cb();
        }
      }
    }, error => {
      this.inProgress = false;
      console.log(error);
      if (this.paymentInfo.amount) {
        this.errorMessage = error.message;
      } else if (!discountCode) {
        this.goBack();
      }
    });
  }

  contains(paymentMode, availablePaymentMods): boolean {
    const mode = availablePaymentMods.find(innerMode => {
      return innerMode === paymentMode;
    });
    return !(!mode);
  }

  generateWithDiscountCode() {
    if (this.Group.valid) {
      this.generateInvoice(this.Group.controls.discountCode.value, this.paymentInfo.paymentMode, null);
    }
  }

  goBack() {
    history.back();
  }

  setChanged() {
    this.changed = true;
  }
}
